import { Line, Sparkles, Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import { COLORS } from "../../constants/colors";
import { useGame } from "../../stores/useGame";
import useDeviceType from "../hooks/useDeviceType";

const BORDER_COLOR = COLORS.surfaceElements;

const SurfaceButtonOpenSN = ({
  position,
  buttonId = "defaultSN",
  width = 2,
  height = 1.5,
}) => {
  const lineRef = useRef();
  const { setButtonOpenSN } = useGame();
  const deviceType = useDeviceType();

  // Создаем массив точек для линии на основе переданных размеров
  const points = [
    [-width, 0, -height],
    [width, 0, -height],
    [width, 0, height],
    [-width, 0, height],
    [-width, 0, -height], // замыкаем контур
  ];

  // Получаем состояние конкретной кнопки
  const isButtonOpenSN = useGame(
    (state) => state.buttonStates[buttonId] || false
  );

  useFrame(({ clock }) => {
    if (lineRef.current) {
      const time = clock.getElapsedTime();

      if (isButtonOpenSN) {
        // Пульсирующая толщина линии
        const pulseWidth = 8 + Math.sin(time * 3) * 4;
        lineRef.current.material.linewidth = pulseWidth;

        // Пульсирующий цвет от #cbb9af к более яркому оттенку
        const colorIntensity = 0.5 + Math.sin(time * 2) * 0.3;
        lineRef.current.material.color.setRGB(
          0.8 + colorIntensity * 0.2, // R (из #cbb9af = 203/255 ≈ 0.8)
          0.73 + colorIntensity * 0.27, // G (из #cbb9af = 185/255 ≈ 0.73)
          0.69 + colorIntensity * 0.31 // B (из #cbb9af = 175/255 ≈ 0.69)
        );
      } else {
        // Возвращаем к исходному цвету #cbb9af
        lineRef.current.material.linewidth = 10;
        lineRef.current.material.color.setRGB(0.8, 0.73, 0.69); // #cbb9af
      }
    }
  });

  return (
    <group position={position}>
      <RigidBody
        type="fixed"
        sensor={true}
        ccd={false}
        userData={{ isButtonOpenSN: true }}
        position-y={1}
        onIntersectionEnter={(other) => {
          if (other.rigidBodyObject?.userData?.isCar) {
            setButtonOpenSN(buttonId, true);
          }
        }}
        onIntersectionExit={(other) => {
          if (other.rigidBodyObject?.userData?.isCar) {
            setButtonOpenSN(buttonId, false);
          }
        }}
      >
        <CuboidCollider args={[width, 0.01, height]} />
      </RigidBody>

      <group position-y={0.1}>
        <Line
          ref={lineRef}
          points={points}
          color={BORDER_COLOR}
          lineWidth={isButtonOpenSN ? 8 : 10}
          dashed={false}
        />
      </group>
      <Text
        fontSize={0.9}
        color={"white"}
        rotation-x={-Math.PI / 2}
        position={[0, 0.01, 0]}
      >
        {isButtonOpenSN
          ? deviceType === "mobile" || deviceType === "tablet"
            ? "GO"
            : "ENTER"
          : "OPEN"}
      </Text>
      {isButtonOpenSN && (
        <Sparkles
          position={[0, 0.5, -2]} // чуть выше поверхности
          count={40}
          scale={[width * 2, height * 2, width * 2]} // область прямоугольника
          size={10}
          speed={1}
          color={"white"}
          opacity={1}
        />
      )}
    </group>
  );
};

export default SurfaceButtonOpenSN;
